import { useCallback, useRef } from 'react';

import { usemarkChatMessagesDeliveredMutation, useworkspaceAuthMeV2Query } from '@/types/generated/graphql';
import { cacheOnly } from '@shared/constants';

export function useAcknowledgeDelivery() {
  const [markDelivered] = usemarkChatMessagesDeliveredMutation({
    onError: () => {},
  });

  const { data: workspaceAuthMe } = useworkspaceAuthMeV2Query(cacheOnly);
  const selfWorkspaceMemberId = workspaceAuthMe?.workspaceAuthMeV2?.data?.currentUserWorkspace?.id;

  const acknowledgedUpTo = useRef(new Map<number, number>());

  return useCallback(
    (params: { roomId?: number | null; chatMessageId?: number | null; senderId?: number | null }) => {
      const { roomId, chatMessageId, senderId } = params;

      if (!roomId || !chatMessageId) return;
      if (!!selfWorkspaceMemberId && senderId === selfWorkspaceMemberId) return;
      if (chatMessageId <= (acknowledgedUpTo.current.get(roomId) ?? 0)) return;

      acknowledgedUpTo.current.set(roomId, chatMessageId);
      markDelivered({ variables: { roomId, upToChatMessageId: chatMessageId } });
    },
    [markDelivered, selfWorkspaceMemberId]
  );
}
